<script lang="ts">
  import ItemLabelValueColumn from "./ItemLabelValueColumn.svelte";

  export let label: string = "";
  export let value: string;
  export let icon: string;
</script>

<div class="flex items-center gap-3 self-center w-full overflow-hidden">
  <img src={icon} alt={label} class="w-6 h-6" />
  <ItemLabelValueColumn {label} {value} />
</div>
